export default __webpack_public_path__ + "static/media/jadwal.4bd30d5b.svg";